module.exports = __webpack_public_path__ + "images/Angle-right.406705f524ca2c36962b97630e96a4f0.svg";